import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { userService } from '../../services/user.service';
import { inviteService } from '../../services/invite.service';
import { departmentService } from '../../services/department.service';
import { FaUsers, FaUserPlus, FaTicketAlt, FaBuilding } from 'react-icons/fa';


const AdminDashboard = () => {
  const [stats, setStats] = useState({
    totalUsers: 0,
    pendingApprovals: 0,
    activeInvites: 0,
    departments: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      setLoading(true);
      
      // Fetch real data from multiple sources
      const [usersData, pendingData, invitesData, departmentsData] = await Promise.all([
        userService.getAllUsers({}).catch(() => ({ users: [] })),
        userService.getAllUsers({ status: 'pending' }).catch(() => ({ users: [] })),
        inviteService.getAllInvites().catch(() => ({ invites: [] })),
        departmentService.getAllDepartments().catch(() => ({ departments: [] }))
      ]);

      setStats({
        totalUsers: usersData.users?.length || 0,
        pendingApprovals: pendingData.users?.length || 0,
        activeInvites: invitesData.invites?.length || 0,
        departments: departmentsData.departments?.length || 0
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      // Keep default values on error
    } finally {
      setLoading(false);
    }
  };

  const menuItems = [
    { name: 'Users', icon: FaUsers, path: '/dashboard/admin/users', color: 'blue' },
    { name: 'Approvals', icon: FaUserPlus, path: '/dashboard/admin/approvals', color: 'yellow' },
    { name: 'Invite Codes', icon: FaTicketAlt, path: '/dashboard/admin/invites', color: 'green' },
    { name: 'Departments', icon: FaBuilding, path: '/dashboard/admin/departments', color: 'purple' },

  ];

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Admin Dashboard</h1>

      {loading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Total Users</p>
                  <p className="text-3xl font-bold text-blue-600 mt-2">{stats.totalUsers}</p>
                </div>
                <FaUsers className="text-4xl text-blue-200" />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Pending Approvals</p>
                  <p className="text-3xl font-bold text-yellow-600 mt-2">{stats.pendingApprovals}</p>
                </div>
                <FaUserPlus className="text-4xl text-yellow-200" />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Active Invites</p>
                  <p className="text-3xl font-bold text-green-600 mt-2">{stats.activeInvites}</p>
                </div>
                <FaTicketAlt className="text-4xl text-green-200" />
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow hover:shadow-lg transition-shadow">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm">Departments</p>
                  <p className="text-3xl font-bold text-purple-600 mt-2">{stats.departments}</p>
                </div>
                <FaBuilding className="text-4xl text-purple-200" />
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-bold mb-4">Quick Actions</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {menuItems.map((item) => (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  className="flex flex-col items-center p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all"
                >
                  <item.icon className="text-3xl text-blue-600 mb-2" />
                  <span className="text-sm font-medium text-center">{item.name}</span>
                </Link>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AdminDashboard;